var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53955 3.5H6.03955",
    stroke: "#F5F5F5",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8104 4.125H11.1838C10.0686 4.125 9.16455 4.96444 9.16455 6C9.16455 7.03556 10.0686 7.875 11.1838 7.875H12.8104C12.8625 7.875 12.8885 7.875 12.9105 7.87369C13.2475 7.85313 13.516 7.60388 13.5381 7.29088C13.5395 7.27044 13.5395 7.24625 13.5395 7.19794V4.80206C13.5395 4.75375 13.5395 4.72954 13.5381 4.70912C13.516 4.39615 13.2475 4.14685 12.9105 4.12634C12.8885 4.125 12.8625 4.125 12.8104 4.125Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8927 4.125C12.8441 2.95481 12.6874 2.23734 12.1823 1.73223C11.4501 1 10.2715 1 7.91455 1H6.03955C3.68253 1 2.50402 1 1.77178 1.73223C1.03955 2.46447 1.03955 3.64298 1.03955 6C1.03955 8.357 1.03955 9.53556 1.77178 10.2677C2.50402 11 3.68253 11 6.03955 11H7.91455C10.2715 11 11.4501 11 12.1823 10.2677C12.6874 9.76269 12.8441 9.04519 12.8927 7.875",
    stroke: "#F5F5F5",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0342 6H11.0461",
    stroke: "#F5F5F5",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.fd6f5b440ae8cd69ff6609b9f36f99b4.svg";
export { ForwardRef as ReactComponent };